import React from 'react';
import DetailedFields from '@modules/members/enrollments/EnrollmentListing/DetailedFields';
import { MM_SLASH_DD_SLASH_YYYY } from '@utils/dates/dateFormats.utils';
import { EMPTY_VALUE } from '../../constants';
import { IPlanCardSectionProps } from '../../types';
import { safeFormatDate } from '../../utils';

// ============================================================================
// Default Labels
// ============================================================================

const DEFAULT_LABELS = {
    enrollmentStatusLabel: 'historical.member.applications.enrollmentStatus',
    effectiveDateLabel: 'historical.member.applications.effectiveDate',
};

const DEFAULT_CLASS_NAME = 'padding-4 margin-bottom-3 border-1px border-base-lighter radius-lg';

// ============================================================================
// Component
// ============================================================================

const PlanCardSection: React.FC<IPlanCardSectionProps> = ({ 
    id,
    enrollment,
    labels = {},
    className = DEFAULT_CLASS_NAME,
}) => {
    const {
        planName = '',
        issuerName = '',
        enrollmentStatus = '',
        enrollmentStartDate = '',
        enrollmentEndDate = '',
    } = enrollment;

    const {
        enrollmentStatusLabel = DEFAULT_LABELS.enrollmentStatusLabel,
        effectiveDateLabel = DEFAULT_LABELS.effectiveDateLabel,
    } = labels;

    const displayStartDate = safeFormatDate(enrollmentStartDate, MM_SLASH_DD_SLASH_YYYY, '');
    const displayEndDate = safeFormatDate(enrollmentEndDate, MM_SLASH_DD_SLASH_YYYY, '');
    
    const effectiveDateRange = displayStartDate || displayEndDate
        ? `${displayStartDate || EMPTY_VALUE} - ${displayEndDate || EMPTY_VALUE}`
        : EMPTY_VALUE;

    return (
        <div id={id} className={className} data-testid={id ? `plan-card-${id}` : undefined}>
            <h3 className="text-center text-uppercase margin-top-0 margin-bottom-1">
                {planName?.toUpperCase() || EMPTY_VALUE}
            </h3>
            <div className="text-center text-base-dark padding-bottom-4 text-uppercase">
                {issuerName?.toUpperCase() || EMPTY_VALUE}
            </div>
            <div className="display-flex flex-justify padding-top-1">
                <DetailedFields
                    label={enrollmentStatusLabel}
                    value={enrollmentStatus || EMPTY_VALUE}
                    dataTestId="enrollment-status"
                    showColon
                    valueClassName="text-bold"
                />
                <DetailedFields
                    label={effectiveDateLabel}
                    value={effectiveDateRange}
                    dataTestId="effective-date"
                    showColon
                    valueClassName="text-bold"
                />
            </div>
        </div>
    );
};

export default PlanCardSection;
